import { render, staticRenderFns } from "./MobileNavigation.vue?vue&type=template&id=24cae7d2&"
import script from "./MobileNavigation.vue?vue&type=script&lang=ts&"
export * from "./MobileNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./MobileNavigation.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MobileNavigationItem: require('/tmp/build_453bf6d7/src/components/navigation/MobileNavigation/MobileNavigationItem.vue').default,NavigationLink: require('/tmp/build_453bf6d7/src/components/navigation/NavigationLink.vue').default})
